import { Alert, Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import React, { useContext } from 'react';
import UserContext from '../UserContext';
import NoOrganisation from '../components/NoOrganisation';
import { PageContainer, PageHeader } from '../components/Page';

export default function SubscriptionConfirmation() {
  const userContext = useContext(UserContext);
  const user = userContext.user;

  const waitingForStripe = user && !user.hasActiveSubscription;

  return (
    <PageContainer>
      <PageHeader title="Welcome to BAS Ready" description="Thanks for subscribing. Connect your clients' Xero organisations to get started." />
      {waitingForStripe ? (
        <Alert
          severity="info"
          icon={<CircularProgress size={18} color="inherit" />}
          action={
            <Button color="inherit" size="small" variant="outlined" onClick={() => userContext.refreshUser()}>
              Check again
            </Button>
          }
        >
          <Stack>
            <Typography sx={{ fontWeight: 600 }}>Finishing your subscription</Typography>
            <Typography variant="body2">Stripe can take a few minutes to confirm the payment. You can check again in a moment.</Typography>
          </Stack>
        </Alert>
      ) : (
        <Box>
          <Alert severity="success" sx={{ mb: 1 }}>
            Your subscription is active.
          </Alert>
          <NoOrganisation alignItems="left" />
        </Box>
      )}
    </PageContainer>
  );
}
